<template>
  <!-- 合作企业录入名单 -->
  <div class="page">
    <div class="paginations">
      <!-- 搜索表单 -->
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">

          <el-form-item label="企业名称：" prop="loginName">
            <el-input size="small" v-model="searchData.companyName" placeholder="请输入企业名称"></el-input>
          </el-form-item>

          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="searcHandler"></i>
            </div>
          </el-form-item>

          <el-form-item>
            <div class="addition">
              <el-button @click="addHandler">
                新增
                <i class="h_icon icon-add"></i>
              </el-button>
            </div>
          </el-form-item>

          <el-form-item>
            <div class="addition">
              <el-button @click="exportTemplate = true" style="width: 62px;height: 33px;">
                导入
              </el-button>
            </div>
          </el-form-item>

        </el-form>
      </div>

      <el-dialog :title="showTitle" :visible.sync="showDialog" width="30%" ref="formName" :close-on-click-modal="false" class="pop_up" append-to-body>
        <el-form :model="addform" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="企业名称：" prop="companyName">
            <el-input v-model="addform.companyName"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitHandler" class="cancal">确 定</el-button>
            <el-button @click="showDialog = false" class="cancal">取 消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 表单内容 -->
      <div class="table_box">
        <el-table :data="tableObj.list" style="width: 100%">
          <el-table-column type="index" label="序号" align='center' width="120">
          </el-table-column>
          <el-table-column prop="institution" label="单位名称" align='center'>
          </el-table-column>
          <el-table-column label="操作" align='center'>
            <template slot-scope="scope">
              <i class="icona icon-edit" title="编辑" @click="editHandler(scope.row)"></i>
              <i class="icona icon-delete" title="删除" @click="delHandler(scope.row.id)"></i>
            </template>
          </el-table-column>
        </el-table>
        <pageNumber :paginations="7" :pageNum="searchData.pageDto.pageNum" :pageSize="searchData.pageDto.pageSize" :total="tableObj.total" :jumpTo="tableObj.jumpTo" @currentChange="jumpHandler"></pageNumber>
      </div>

      <!-- 模板弹窗 -->
      <el-dialog title="导入" :visible.sync="exportTemplate" width="30%" ref="formName" :close-on-click-modal="false" class="pop_up" append-to-body>
        <el-row>
          <el-col :span="24" class="downloadTem">
            模板下载：
            <el-button type="primary" @click="downloadTemplate" size="small">下载模板</el-button>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" class="exportTem">
            模板导入：
            <el-upload class="upload" action="#" :show-file-list="false" :on-change="clearhandleExcel" accept="'.xlsx','.xls'" :auto-upload="false" :headers="headers">
              <el-button size="mini" type="primary" class="export">导入</el-button>
            </el-upload>
            <el-radio v-model="radio" :label="false" style="margin-left: 10px;">增量导入</el-radio>
            <el-radio v-model="radio" :label="true">清除原数据导入</el-radio>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import pageNumber from '@/components/pageNumber.vue'; // 分页

export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      searchData: {
        companyName: '',
        pageDto: {
          pageNum: 1,
          pageSize: 10,
        },
      },

      radio: false,

      addform: {
        companyName: '',
      },
      showDialog: false,

      tableObj: {
        list: [],
        total: 0,
        jumpTo: 1,
      },
      showTitle: '',
      fileList: [],

      exportTemplate: false,

      headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },

    };
  },
  created() {
    this.initTableList();
  },
  methods: {
    // 初始化表格数据
    initTableList() {
      this.$axios.post(this.$apiurls.cooperativeEnterprise_getCompanyLists, this.searchData, {
        loading: false,
      }).then((res) => {
        this.tableObj.list = res.data.list;
        this.tableObj.total = res.data.total;
      });
    },

    // 点击页码数跳转
    jumpHandler(pageNum) {
      const obj = {
        companyName: '',
        pageDto: {
          pageNum,
          pageSize: 10,
        },
      };
      this.$axios.post(this.$apiurls.cooperativeEnterprise_getCompanyLists, obj, {
        loading: false,
      }).then((res) => {
        this.tableObj.list = res.data.list;
        this.tableObj.total = res.data.total;
      });
    },

    searcHandler() {
      this.$axios.post(this.$apiurls.cooperativeEnterprise_getCompanyLists, this.searchData, {
        loading: false,
      }).then((res) => {
        this.tableObj.list = res.data.list;
        this.tableObj.total = res.data.total;
      });
    },

    // 新增操作
    addHandler() {
      this.showDialog = true;
      this.showTitle = '新增';
      this.addform.companyName = '';
    },

    // 编辑操作
    editHandler(row) {
      this.showDialog = true;
      this.showTitle = '编辑';
      this.addform.companyName = row.institution;
      this.addform.id = row.id;
    },

    // 删除操作
    delHandler(id) {
      this.$axios.post(this.$apiurls.cooperativeEnterprise_deleteCompanyInfo, id, {
        loading: false,
      }).then((res) => {
        this.$confirm('是否确定删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.initTableList();
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
      });
    },

    // 新增表格数据
    submitHandler() {
      this.$axios.post(this.$apiurls.cooperativeEnterprise_saveOrUpdateCompany, {
        id: this.showTitle == '新增' ? 0 : this.addform.id,
        companyName: this.addform.companyName,
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: this.showTitle == '新增' ? '新增成功' : '更改成功',
            type: 'success',
          });
          this.showDialog = false;
          this.initTableList();
        }
      });
    },

    // 下载模板
    downloadTemplate() {
      const a = document.createElement('a');
      //  地址路径
      a.href = './export/template.xls';
      a.download = '合作企业名单录入.xlsx';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    // 数据导入
    clearhandleExcel(file) {
      const formData = new FormData(); // 声明一个FormDate对象
      formData.append('file', file.raw); // 把文件信息放入对象中
      // 调用后台导入的接口
      this.$axios.post(`${this.$apiurls.cooperativeEnterprise_uploadFile}?isClear=${this.radio}`, formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        formData: true,
      }).then((res) => {
        if (res.data) {
          this.$message.success('导入成功');
          this.exportTemplate = false;
          this.initTableList();
        } else {
          this.$message({
            type: 'error',
            message: '导入失败',
          });
        }
      });
    },
  },
};
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" >
.el-form {
  height: 100%;
}

.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.search_button i {
  width: 33px;
  height: 33px;
  /* background: rgba(46, 62, 99, 0.79); */
  border-radius: 4px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
}

.inp-xlsx {
  opacity: 0;
}

.cancal {
  background: #4f5770;
  color: white;
  border: none;
}

.cancal:hover {
  background: #17ded4;
  color: #fff;
}

.addition button:hover {
  background: rgba(46, 62, 99, 0.7);
}

.addition button:active {
  background: rgba(46, 62, 99, 0.7) !important;
  color: #17ded4 !important;
}

.downloadTem {
  color: white;
}

.exportTem {
  margin-top: 20px;
  color: white;
}

.upload {
  display: inline-block;
}

.export {
  width: 80px;
}

.el-upload {
  padding: 0px;
  border: 0px dashed #707383;
}

.el-upload--text {
  padding: 0px !important;
  border: none !important;
}
</style>
